import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet';
import SignupForm from './utils/SignupForm';
import { Link } from 'react-router-dom';
import HealthSection from './utils/HealthSection';

const HydrationStrategiesForOptimalPerformance = () => {
    return (
        <div>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Hydration for Peak Performance</h1>
                    <h2>Unlock your full potential with Ramp Physio and Fitness's expert guide to hydration strategies, tailored to enhance your performance and health.</h2>
                    <p>Staying adequately hydrated is a cornerstone of optimal physical performance and overall health. At Ramp Physio and Fitness, we understand that hydration goes beyond simply drinking water. It's about understanding your body's needs and implementing strategies that ensure you're well-hydrated before, during, and after exercise. This comprehensive guide will provide you with insights into the science of hydration and practical tips to stay at the top of your game.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Hydration Strategies" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>The Science of Hydration</h1>
                        <p>Effective hydration is more than quenching thirst—it's about maintaining the balance of fluids in your body to support all physiological functions. Dehydration can impair your cognitive function, reduce endurance, and increase the risk of heat-related illnesses. Our hydration strategies are backed by scientific research and tailored to your individual needs, helping you maintain that essential balance for peak performance and recovery.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            </SkewedContainer>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Hydration Before Exercise</h1>
                    <p>Preparing your body for a workout starts with proper hydration. Consuming fluids prior to exercise ensures that you begin your session in a hydrated state, which can enhance endurance, prevent early fatigue, and reduce the risk of heat stress. We'll guide you on how much to drink and which fluids are best for pre-exercise hydration, considering factors such as the duration and intensity of your workout, as well as environmental conditions.</p>
                </div>
            </div>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Hydration During Exercise</h1>
                    <p>Staying hydrated throughout your workout is crucial for maintaining performance, especially during prolonged or high-intensity exercise. We'll help you develop a hydration plan that matches your sweat rate and the specific demands of your activity. This includes choosing the right kind of fluids and understanding the role of electrolytes in maintaining hydration and preventing cramps.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Hydration After Exercise</h1>
                    <p>Recovery is an integral part of any fitness regimen, and rehydrating after exercise is key to that process. We'll show you how to effectively replenish fluids and electrolytes lost during exercise to aid recovery, prevent dehydration, and prepare your body for the next workout. Additionally, we'll discuss the importance of recognizing personal signs of dehydration and the best strategies for monitoring hydration status.</p>
                    <br></br>
                    <p>
                        In conclusion, proper hydration is essential for achieving peak performance, whether you're an athlete, a fitness enthusiast, or someone looking to improve their overall health. At Ramp Physio and Fitness, we are committed to providing you with evidence-based hydration strategies that are tailored to your unique needs. By understanding and applying these principles, you'll be able to train harder, recover faster, and perform better. Stay hydrated and reach new heights with us.
                    </p>
                </div>
            </div>
            </SkewedContainer>
            
    <SubpagesLink />
    <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default HydrationStrategiesForOptimalPerformance;